import React from 'react';
import { Link } from 'react-router-dom';

const Plans = () => {
    return (
        <main>
            <section className="spacer"></section>

            <section className="plans" id="plans">
                <div className="main-text">
                    <h2>Flexible Membership Plans</h2>
                    <p>Choose the plan that fits your lifestyle and start your fitness journey today. No hidden fees, just
                        results.</p>
                </div>

                <div className="plan-content">

                    <div className="card">
                        <h3>Starter Package</h3>
                        <div className="price">₹1500<span>/month</span></div>
                        <ul>
                            <li><i className="fa-solid fa-check"></i> Standard Fitness Fever Access</li>
                        </ul>
                        <Link to="/contact" className="btn plan-btn">GET PLAN</Link>
                    </div>

                    <div className="card">
                        <h3>Silver Package</h3>
                        <div className="price">₹2000<span>/month</span></div>
                        <ul>
                            <li><i className="fa-solid fa-check"></i>Fitness Fever + Cardio access</li>
                        </ul>
                        <Link to="/contact" className="btn plan-btn">GET PLAN</Link>
                    </div>
                    


                    <div className="card popular">
                        <h3>Vip Package</h3>
                        <span className="best-value">BEST VALUE</span>
                        <div className="price">₹9999<span>/month</span></div>
                        <ul>
                            <li><i className="fa-solid fa-check"></i>6 months</li>
                            <li><i className="fa-solid fa-check"></i>  1-on-1 Trainer Session</li>
                            <li><i className="fa-solid fa-check"></i>  Nutritional Plan</li>
                            <li><i className="fa-solid fa-check"></i>  Guaranteed Results</li>

                        </ul>
                        <Link to="/contact" className="btn plan-btn">GET PLAN</Link>
                    </div>
                    <div className="card">
                        
                        <h3>Diet Package</h3>
                        <div className="price">₹2500<span>/month</span></div>
                        <ul>
                            <li><i className="fa-solid fa-check"></i> Consultation</li>
                            <li><i className="fa-solid fa-check"></i> Nutritional Diet Plan</li>

                        </ul>
                        <Link to="/contact" className="btn plan-btn">GET PLAN</Link>
                    </div>

                </div>
            </section>
        </main>
    );
};

export default Plans;
